<template>
  <div id="app">
    <v-container>
      <v-card class="mx-auto" max-width="1000" v-if="reportData">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text"
            >Equipment Log Report</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="reportHeader"
            :items="tableData"
            :sort-by="['name']"
            class="elevation-1"
            :search="search"
          ></v-data-table>
          <div class="text-center pt-2">
            <v-btn color="accent" @click="downloadCSV()">
              Download CSV
              <v-icon right dark>mdi-file-excel</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { hpUser } from "../classes/hpUser";
import _ from "lodash";
export default {
  props: {
    reportData: Array
  },
  data() {
    return {
      search: "",
      reportHeader: [
        {
          text: "Name",
          sortable: true,
          value: "name"
        },
        { text: "Category", value: "category" },
        { text: "Product", value: "product" },
        { text: "Model", value: "model" },
        { text: "Serial", value: "serial" },
        { text: "Assigned", value: "assigned" }
      ],
      tableData: [],
      hpUsers: []
    };
  },
  async created() {
    const that = this;
    this.hpUsers = [];

    let hpUserObj = new hpUser();
    this.hpUsers = await hpUserObj.getUsers();
    this.hpUsers = _.orderBy(this.hpUsers, "firstName", "asc");

    this.reportData.map(function(report) {
      const assignedToPerson = that.hpUsers.filter(
        user => user.username === report.assigned
      );

      report.equipmentLogAsset.items.map(function(asset) {
        that.tableData.push({
          id: asset.id,
          name: report.name,
          category: asset.category,
          product: asset.product,
          hpReference: asset.hpReference,
          model: that.truncate(asset.model),
          serial: asset.serial,
          purchaseDate: asset.purchaseDate,
          cost: asset.cost,
          assigned:
            assignedToPerson.length > 0
              ? `${assignedToPerson[0].firstName} ${
                  assignedToPerson[0].lastName
                }`
              : report.assigned
        });
      });
    });
  },
  methods: {
    csvExport() {
      const arrData = this.tableData;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    downloadCSV() {
      this.csvExport();
    },
    truncate(input) {
      if (input.length > 20) {
        return input.substring(0, 20) + "...";
      } else {
        return input;
      }
    }
  }
};
</script>
